module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-8-5c661a361ce9eb6c66972f81dfa7bec9.jpg";